export const removeCurrency = (currencyString: string): string =>
  currencyString.replace(/[^0-9,-]+/g, '');
